<template>
  <v-app>
    <v-app-bar
      v-show="this.$route.name !== 'error'"
      fixed
      dense
      flat
      style="z-index: 50"
      :height="headerHeight"
      :color="scrollColor"
      :class="{scrollHeader: scroll}"
    >
      <router-link to="/" style="width: 100px">
        <img :src="logo" style="width: 50%" alt="Aimm" @click="toHome" />
      </router-link>
      <div style="margin-left:120px; height: 96px;" class="d-none d-sm-none d-md-flex">
        <ul class="nav-menu-inner">
          <li @click="toHome">
            <a class="routerlink" :class="{ scrollText: scrollText }">{{ $t('header.premium') }}</a>
          </li>
          <v-spacer></v-spacer>
          <li>
            <a
              class="routerlink"
              :class="{ scrollText: scrollText }"
              @click="toAbout"
            >{{ $t('header.about_us') }}</a>
          </li>
          <v-spacer></v-spacer>
          <li>
            <a
              class="routerlink"
              :class="{ scrollText: scrollText }"
              href="https://aimatchmaker.com/blog/"
              target="__blank"
            >{{ $t('header.blog') }}</a>
          </li>
        </ul>
      </div>
      <v-spacer></v-spacer>
      <div style="margin-right: 15px; display: flex" class="d-none d-sm-none d-md-flex">
        <span class="language">Language</span>
        <span class="font-sm" :class="{ scrollText: scrollText }" @click="changeLanguage('en')">EN</span>
        <span style="color: #000">/</span>
        <span class="font-sm" :class="{ scrollText: scrollText }" @click="changeLanguage('zh')">中</span>
      </div>
      <v-btn icon style="margin-right: 15px" class="d-none d-sm-none d-md-flex" @click="toFb">
        <img src="./assets/img/icon_fb.svg" width="30px" />
      </v-btn>
      <v-btn icon class="d-none d-sm-none d-md-flex" @click="sendMail">
        <img src="./assets/img/icon_email.svg" width="30px" />
      </v-btn>
      <a class="m-bar d-none d-flex d-sm-flex d-md-none" @click="drawer = !drawer">
        <i class="nav-bar-icon" :class="{ active: drawer, scrollIcon: scrollText }">
          <span></span>
        </i>
      </a>
    </v-app-bar>
    <router-view></router-view>
    <Footer></Footer>
    <v-navigation-drawer v-model="drawer" fixed temporary right class="side-bar" width="200">
      <ul class="sidebar-nav">
        <div style="margin-bottom: 10px; display: flex; justify-content: center">
          <img src="./static/img/la_logo.png" style="height:50px;" />
        </div>
        <hr class="white" />
        <li @click="toHome">
          <a
            class="sidebar-li"
            style="color: #000; text-decoration:none; width: 140px"
          >{{ $t('header.premium') }}</a>
        </li>
        <li @click="toAbout">
          <a
            class="sidebar-li"
            style="color: #000; text-decoration:none; width: 140px"
          >{{ $t('header.about_us') }}</a>
        </li>
        <li>
          <a
            href="https://aimatchmaker.com/blog/"
            target="__blank"
            class="sidebar-li"
            style="color: #000; text-decoration:none; width: 140px"
          >{{ $t('header.blog') }}</a>
        </li>
        <hr class="white" />
        <p class="sidebar-li" @click="changeLanguage('en')">English</p>
        <p class="sidebar-li" @click="changeLanguage('zh')">繁體中文</p>
        <hr class="white" />
        <p class="sidebar-li" @click="toFb">Facebook</p>
        <p class="sidebar-li" @click="sendMail">Email Us</p>
      </ul>
    </v-navigation-drawer>
  </v-app>
</template>

<script>
import Footer from "./components/Footer.vue";
export default {
  components: {
    Footer,
  },
  data() {
    return {
      drawer: false,
      scrollColor: "rgba(1, 1, 1, 0)",
      headerHeight: 94,
      scroll: false,
      logo: require("./static/img/la_logo.png"),
      scrollText: false,
    };
  },
  mounted() {
    if (window.navigator.language.indexOf("zh") !== -1) {
      // 中文
      this.$i18n.locale = "zh";
      this.$store.commit("globalVar/setLanguage", { language: "zh" });
    } else {
      // 英文
      this.$i18n.locale = "en";
      this.$store.commit("globalVar/setLanguage", { language: "en" });
    }
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (scrollTop > 130) {
        // header 變色
        this.scrollColor = "rgba(255, 255, 255, 0.95)";
        this.scroll = true;
        this.scrollText = true;
        this.logo = require("./static/img/la_logo.png");
      } else {
        this.scrollColor = "rgba(1, 1, 1, 0)";
        this.scroll = false;
        this.scrollText = false;
        this.logo = require("./static/img/la_logo.png");
      }
      if (scrollTop > 1) {
        // header 高度
        this.headerHeight = 64;
      } else {
        this.headerHeight = 94;
      }
    },
    toFb() {
      window.open("https://www.facebook.com/thisistilaine");
    },
    sendMail() {
      window.location.href = "mailto:service@aimatchmaker.com";
    },
    changeLanguage(lng) {
      this.$store.commit("globalVar/setLanguage", { language: lng });
      this.$i18n.locale = lng;
    },
    toHome() {
      if (this.$route.name === "main") {
        history.go(0);
        return false;
      }
      this.$router.replace("/");
      setTimeout(() => {
        let element = document.querySelector("#mainTop");
        window.scrollTo({
          top: window.pageYOffset + element.getBoundingClientRect().top + 10,
          behavior: "smooth",
        });
        // TODO: 追蹤ga
      }, 300);
    },
    toAbout() {
      if (this.$route.name === "about") {
        history.go(0);
        return false;
      }
      this.$router.push({ path: "/about" });
      setTimeout(() => {
        let element = document.querySelector("#aboutTop");
        window.scrollTo({
          top: window.pageYOffset + element.getBoundingClientRect().top + 10,
          behavior: "smooth",
        });
        // TODO: 追蹤ga
      }, 300);
    },
  },
};
</script>

<style lang="scss" scoped>
.v-application {
  font-family: "Noto Sans TC", sans-serif !important;
}
::v-deep .v-toolbar__content,
.v-toolbar__extension {
  padding-right: 65px;
  padding-left: 65px;
}
.nav-menu-inner {
  margin: 0;
  padding: 0;
  list-style: none;
  height: 100%;
  display: flex;
  li {
    height: 100%;
    width: 120px;
    display: flex;
    align-items: center;
    justify-content: center;
    list-style: none;
    text-align: center;
  }
  .routerlink {
    display: flex;
    align-items: center;
    height: 100%;
    font-size: 16px;
    line-height: 1;
    font-weight: 500;
    outline: none;
    letter-spacing: 2px;
    color: #fff;
    transition: all 0.27s cubic-bezier(0, 0, 0.58, 1) 0s;
    text-decoration: none;
    &:hover {
      color: #df4c6f;
    }
  }
}
.side-bar {
  background-color: #F2F2F2 !important;
  color: #000;
  z-index: 100;
}
.sidebar-nav {
  padding: 30px;
  list-style: none;
  width: 100%;
  color: #000;
  hr {
    border: 0;
    height: 0;
    color: #000;
  }
  .white {
    border-top: 1px solid #000 !important;
    margin-top: 20px;
    margin-bottom: 20px;
  }
  li {
    display: flex;
    align-content: center;
    min-height: 15px;
    margin-top: 15px;
    cursor: pointer;
  }
  a {
    cursor: pointer;
    font-size: 16px;
    font-weight: 500;
    transition: all 0.27s cubic-bezier(0, 0, 0.58, 1) 0s;
    &:hover {
      color: #000;
    }
  }
}
.font-sm {
  cursor: pointer;
  min-width: 60px;
  text-align: center;
  color: #000;
  font-size: 14px;
  line-height: 24px;
  transition: all 0.27s cubic-bezier(0, 0, 0.58, 1) 0s;
}
.scrollHeader {
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.3);
  li {
    color: #323232;
  }
}
.m-bar {
  transition: all 0.27s cubic-bezier(0, 0, 0.58, 1) 0s;
  cursor: pointer;
  width: 40px;
  display: flex;
  color: #fff;
  justify-content: center;
  &:hover {
    color: #df4c6f;
  }
}
.scrollText {
  cursor: pointer;
  transition: all 0.27s cubic-bezier(0, 0, 0.58, 1) 0s;
  color: #323232 !important;
  &:hover {
    color: #df4c6f !important;
  }
}
.scrollIcon {
  span {
    background-color: #323232 !important;
    &:before,
    &:after {
      background-color: #323232 !important;
    }
    &:hover,
    &:hover:before,
    &:hover:after {
      background-color: #df4c6f !important;
    }
  }
}
.language {
  font-style: italic;
  opacity: 0.6;
  margin-right: 5px;
  margin-right: 24px;
  min-width: 60px;
  text-align: center;
  font-size: 14px;
  line-height: 24px;
  transition: all 0.27s cubic-bezier(0, 0, 0.58, 1) 0s;
  width: 40px;
  display: flex;
  color: #000;
  justify-content: center;
}
.no-hover-text {
  color: #323232 !important;
}
.nav-bar-icon {
  width: 30px;
  height: 30px;
  span {
    position: absolute;
    top: 50%;
    display: block;
    width: 18px;
    height: 2px;
    margin-top: -1px;
    background-color: #000;
    transition: transform 0.3s, background 0.25s ease;
    &:before,
    &:after {
      content: "";
      position: absolute;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: #000;
      -webkit-transition: -webkit-transform 0.3s, background 0.25s ease;
      -webkit-transition: background 0.25s ease, -webkit-transform 0.3s;
      transition: background 0.25s ease, -webkit-transform 0.3s;
      transition: transform 0.3s, background 0.25s ease;
      transition: transform 0.3s, background 0.25s ease, -webkit-transform 0.3s;
    }
    &:before {
      -webkit-transform: translateY(-6px);
      transform: translateY(-6px);
      -o-transform: translateY(-6px);
      -ms-transform: translateY(-6px);
      -moz-transform: translateY(-6px);
    }
    &:after {
      -webkit-transform: translateY(6px);
      transform: translateY(6px);
      -o-transform: translateY(6px);
      -ms-transform: translateY(6px);
      -moz-transform: translateY(6px);
    }
    &:hover,
    &:hover:before,
    &:hover:after {
      background-color: #df4c6f;
    }
  }
  &.active {
    transform: rotate(45deg);
    -moz-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    -o-transform: rotate(45deg);
    -webkit-transform: rotate(45deg);
    span {
      &:before {
        transform: rotate(90deg);
        -moz-transform: rotate(90deg);
        -ms-transform: rotate(90deg);
        -o-transform: rotate(90deg);
        -webkit-transform: rotate(90deg);
      }
      &:after {
        transform: rotate(90deg);
        -moz-transform: rotate(90deg);
        -ms-transform: rotate(90deg);
        -o-transform: rotate(90deg);
        -webkit-transform: rotate(90deg);
      }
    }
  }
}
</style>
